import React, {useMemo} from 'react';
import {Props} from './Props';

export const LevelDash: React.FunctionComponent<Props> = ({level}) => {
    return (
        <>{useMemo(() => Array.from(Array(level).keys()).map((_, index) => <span key={index}>- </span>), [level])}</>
    );
};
